import React from "react";
import "./Common_banner_holder.css";

function Common_banner_holder({imgSrc}) {
  return (
    <>
      <section className="Common_banner_holder">
        <div className="container-fluid p-0">
          <div className="img_holder">
            <img className="banner_holder" alt="banner" src={imgSrc} />
          </div>
        </div>
      </section>
    </>
  );
}

export default Common_banner_holder;
